module.exports = __webpack_public_path__ + "static/media/3275433.207d5a69.svg";